var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "discrete",
    values: "1;0.5;0.5",
    dur: "900ms",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    opacity: 0.5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "discrete",
    values: "0.5;1;0.5",
    dur: "900ms",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    opacity: 0.5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "discrete",
    values: "0.5;0.5;1",
    dur: "900ms",
    repeatCount: "indefinite"
  }))));
}
export default SvgLoader;